import {createSlice} from '@reduxjs/toolkit';
import {getAccountLicenseHistorySuccess} from 'src/openapi/admin/apis/GetAccountLicenseHistoryApi';
import {getLicenseSuccess} from 'src/openapi/admin/apis/GetLicenseApi';

import type {LicenseInfo} from 'src/openapi/admin/models/LicenseInfo';
import type {AppState} from 'src/store/typedef';

type InitialState = {
    license: LicenseInfo | null,
    licenseHistory: Array<LicenseInfo> | null,
};

export const initialState: InitialState = {
    license: null,
    licenseHistory: null,
};

export const accountLicenseFeaturesSlice = createSlice({
    name: 'accountLicenseFeatures',
    initialState,
    reducers: {
        clearAccountLicenseHistory: state => {
            state.licenseHistory = null;
        },
        clearAccountLicense: state => {
            state.license = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getLicenseSuccess, (state, action) => {
                state.license = action.payload.data;
            })
            .addCase(getAccountLicenseHistorySuccess, (state, action) => {
                state.licenseHistory = action.payload.data;
            });
    },
});

export const {
    clearAccountLicense,
    clearAccountLicenseHistory,
} = accountLicenseFeaturesSlice.actions;


type SelectAccountLicense = (state: AppState) => LicenseInfo | null;
export const selectAccountLicense: SelectAccountLicense = state =>
    state.accountPage.tabs.licenseAndFeatures.license.license;

type SelectAccountLicenseHistory = (state: AppState) => Array<LicenseInfo> | null;
export const selectAccountLicenseHistory: SelectAccountLicenseHistory = state =>
    state.accountPage.tabs.licenseAndFeatures.license.licenseHistory;
